import { TextField, Typography, Box, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import { setHomePage, useMaterialUIController } from "context";
import useAuth from "hooks/useAuth";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { JsonTool } from "utils/jsonTools";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { API_URL, API_ROUTES, MenuProps } from "../../utils/constants";
import { InterestsSharp, ShareOutlined } from "@mui/icons-material";
import { Link } from "react-router-dom";

export default function Share() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const { accessToken, user } = useAuth();
  const axiosPrivateInstance = useAxiosPrivate();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          //borderBottom: 1,
          borderColor: "divider",
          padding: "1rem 1rem 0 1rem",
        }}
      >
        <Grid container spacing={2} sx={{ textAlign: "left" }} mt={"0px"}>
          <Grid item xs={12} md={12} lg={12}>
            <Typography fontSize={"0.75rem"} color={"#000000"} fontWeight={500}>
              Tích hợp đồng bộ dữ liệu
            </Typography>
            <TextField
              fullWidth
              name="ocop_ip_tw"
              value={""}
              //   onChange={handleChangeValueInput("note")}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <MDButton
              color="primary"
              type="submit"
              variant="contained"
              startIcon={<InterestsSharp />}
              size="small"
              //   onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Đồng bộ dữ liệu
            </MDButton>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Typography fontSize={"0.75rem"} color={"#000000"} fontWeight={500}>
              Chia sẽ dữ liệu (Hệ thống cung cấp tính năng chia sẽ dữ liệu cho
              các hệ thống khác thông qua API, Webservice), nhấn vào nút Chia sẽ
              bên dưới
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <MDButton
              color="info"
              target="_blank"
              href={`${API_URL}/docs`}
              variant="contained"
              startIcon={<ShareOutlined />}
              size="small"
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Chia sẽ dữ liệu
            </MDButton>
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </DashboardLayout>
  );
}
